import React from 'react';
import { Box, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

/**
 * Auth layout: login/register full-screen centering.
 * Spacing scale for auth pages: 2, 3, 4, 8 (theme units). Use mt/mb/p with these
 * so Login and Register stay consistent (e.g. outer mt: 8, logo mb: 3, card p: 4, form mt: 3, button mt: 4 mb: 2).
 */
const AuthLayout = () => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: theme.palette.grey[100],
                p: 3,
            }}
        >
            <Outlet />
        </Box>
    );
};

export default AuthLayout; 